import firebase from 'firebase';

const firebaseConfig = {
  apiKey: 'AIzaSyDMXaE7k2aqhPcqwfF14pJE59TsOteeHHA',
  authDomain: 'clone-69de9.firebaseapp.com',
  databaseURL: 'https://clone-69de9.firebaseio.com',
  projectId: 'clone-69de9',
  storageBucket: 'clone-69de9.appspot.com',
  messagingSenderId: '447789303574',
  appId: '1:447789303574:web:5e632bc6a21a3df05ef237',
  measurementId: 'G-L8P1V4FE4N',
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { db, auth, provider };
